import { PaymentPlan, paymentPlanOrder } from 'api/types/owner';

export function hasMinimumPlan(ownerPlan: PaymentPlan, minimumPlan: PaymentPlan) {
  return paymentPlanOrder[ownerPlan] >= paymentPlanOrder[minimumPlan];
}
